import { API_BASE_URL } from '../config/api';

// A production build cannot enable the sandbox, even with the flag set.
export const localSandboxEnabled = process.env.NODE_ENV === 'development'
  && process.env.REACT_APP_LOCAL_SANDBOX === 'true'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname)
  && /^http:\/\/(localhost|127\.0\.0\.1):\d+$/.test(API_BASE_URL);

export async function localSession(action, body) {
  if (!localSandboxEnabled) throw new Error('Local sandbox is disabled');
  const response = await fetch(`${API_BASE_URL}/local/${action}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Local request failed');
  return { tokens: { idToken: result.token, accessToken: result.token } };
}
